import { Component, OnInit, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { StrategyMapDownloadService } from '../strategy-map-download.service';
import { IWorkspace } from '../../../models/IWorkspace';
import { TabView, Chips } from 'primeng/primeng';


@Component({
  selector: 'app-strategy-map-recipients',
  templateUrl: './strategy-map-recipients.component.html',
  styleUrls: ['./strategy-map-recipients.component.scss']
})
export class StrategyMapRecipientsComponent implements OnInit, AfterViewInit {
  @Output() close = new EventEmitter<void>();
  @ViewChild(Chips) chipsControl: Chips;
  @ViewChild(TabView) tabView: TabView;
  readonly MAX_EMAIL_RECIPIENTS = 49;
  readonly EMAIL_HEADER = 'Email';
  readonly WORKSPACE_HEADER = 'eProve™ workspace';

  constructor(private strategyMapDownloadService: StrategyMapDownloadService) { }

  public emails: string[] = [];
  selectedWorkspace: any;

  emailIsInvalid: boolean;
  noEmailsEntered: boolean;
  maxEmailLimit: boolean;
  workspaceNotSelected: boolean;

  chipsInput: HTMLInputElement;

  emailPattern = new RegExp (['^(([^<>()[\\]\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\.,;:\\s@\"]+)*)',
    '|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.',
    '[0-9]{1,3}\])|(([a-zA-Z\\-0-9]+\\.)+',
    '[a-zA-Z]{2,}))$'].join(''));


  ngOnInit() {}

  ngAfterViewInit() {
    this.chipsInput = this.chipsControl.el.nativeElement.querySelector('input');
    this.chipsInput.addEventListener('keyup', this.onKeypressChipsInput.bind(this), true);
    this.chipsInput.addEventListener('paste', this.onPasteChipsInput.bind(this), false);
  }

  get emailsAvailable(): number {
    return this.MAX_EMAIL_RECIPIENTS - this.emails.length;
  }

  onKeypressChipsInput(event: KeyboardEvent): void {
    // if they press semicolon
    if (event.code === '186') {
      // push the string to the array of emails, minus the semicolon
      this.emails.push(this.chipsInput.value.slice(0, -1));
      // run validation on it
      this.onEmailAdded();
      // reset the input
      this.chipsInput.value = '';
    }
  }

  onPasteChipsInput(event: ClipboardEvent): void {
    // get the text that's being pasted in
    const data = this.getClipboardData(event);

    // regex for one or more spaces, commas or semicolons
    const delimeters = new RegExp(/[ ,;<>]+/);

    // split based on those values
    const emailsToValidate = data.split(delimeters);

    // validate
    emailsToValidate.forEach(e => {
      // make sure we have space
      if (this.emails.length < this.MAX_EMAIL_RECIPIENTS) {
        // valid email format
        if (this.emailPattern.test(e)) {
          this.emails.push(e);
        }
      }
    });

    // we're done with the event
    // we don't want it to append to the input value
    event.preventDefault();
  }

  get workspaces(): IWorkspace[] {
    return this.strategyMapDownloadService.workspaces;
  }

  onHideModalClick(): void {
    this.strategyMapDownloadService.clearVisible();
    this.close.emit();
  }

  onWorkspaceClick(workspace: IWorkspace) {
    this.selectedWorkspace = workspace;
  }

  onClickDownloadButton(): void {
    const selectedHeader = this.tabView.tabPanels.find(x => x.selected === true).header;
    if (selectedHeader === this.EMAIL_HEADER) {
      // if there's remaining input that hasn't been tokenized
      if (this.chipsInput.value) {
        // add it to the array
        this.emails.push(this.chipsInput.value);
        // and then validate it
        this.onEmailAdded();
      }
      this.selectedWorkspace = null;
      this.noEmailsEntered = this.emails === undefined || this.emails.length === 0;
      if (!this.noEmailsEntered) {
        this.strategyMapDownloadService.submitShareForm(this.emails, null);
      }
    } else if (selectedHeader === this.WORKSPACE_HEADER) {
      this.workspaceNotSelected = this.selectedWorkspace === undefined;
      this.emails = [];
      if (!this.workspaceNotSelected) {
        this.strategyMapDownloadService.submitShareForm(null, this.selectedWorkspace.workspaceId);
      }
    }
  }

  onEmailAdded(): void {
    const indexJustAdded = this.emails.length - 1;
    const emailJustAdded = this.emails[indexJustAdded];

    // check if we're over the limit of recipients
    this.maxEmailLimit = this.emails.length > this.MAX_EMAIL_RECIPIENTS;
    // check it's a valid format
    this.emailIsInvalid = !this.emailPattern.test(emailJustAdded);
    // if it's invalid remove it from the list.
    if (this.emailIsInvalid || this.maxEmailLimit) {
      const index = this.emails.indexOf(emailJustAdded);
      this.emails.splice(index, 1);
    }

    this.noEmailsEntered = this.emails.length === 0;
  }

  onTabChange(): void {
    // reset all validation when they change a tab, since it's a new form
    this.emailIsInvalid = false;
    this.noEmailsEntered = false;
    this.workspaceNotSelected = false;
  }

  private getClipboardData(event: ClipboardEvent): string {
    // for IE 11, get the data from the event, only if it exists
    if (event.clipboardData !== undefined) {
      return event.clipboardData.getData('text/plain');
    } else { // otherwise look on the window obj
      return window['clipboardData'].getData('Text');
    }
  }

}
